
 App.directive('appFileversions', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/fileversions.html',
        controller: 'FileVersionsController',
        restrict: 'E',
        replace: true,
        scope: {
          file: '=file',
          downloadable: '=downloadable',
          name: '=name'
        }
    };
  
  });